import { NEW_PORTAL_FEATURE_FLAG } from 'shared/constants';
import { isDevelopment } from 'shared/utils/environment';
import { useIsFeatureFlagEnabled, useLoadFeatureFlags } from 'shared/utils/feature-flags';
import DebtorReaction from './DebtorReaction';
import { LegacyPortalRedirect } from './LegacyPortalRedirect';

export const DebtorReactionRoute = () => {
  useLoadFeatureFlags();
  const isNewPortalEnabled = useIsFeatureFlagEnabled(NEW_PORTAL_FEATURE_FLAG);

  return isNewPortalEnabled && !isDevelopment() ? <LegacyPortalRedirect /> : <DebtorReaction />;
};
